import React from "react";
import { Link } from "react-router-dom";
import "./skins.css";

function payloadRows(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return [];
  }
  return Object.entries(payload).slice(0, 4);
}

function preferredRows(payload, displayKeys = []) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return [];
  }

  const keys = Array.isArray(displayKeys) ? displayKeys.filter(Boolean) : [];
  if (!keys.length) {
    return payloadRows(payload);
  }

  const rows = keys
    .filter((key) => Object.prototype.hasOwnProperty.call(payload, key))
    .map((key) => [key, payload[key]]);

  return rows.length ? rows : payloadRows(payload);
}

export default function BasicMainCardSkin({ card }) {
  const rows = preferredRows(card?.latest_event?.payload, card?.display_keys);
  const device = card?.device || {};
  const item = card?.item || {};

  return (
    <article className="main-card-skin-basic">
      <div className="main-card-skin-basic__top">
        <div>
          <span className="main-card-skin-basic__eyebrow">
            {device.group?.name || device.group?.group_code || "메인 카드"}
          </span>
          <h3>{item.name || device.name || "디바이스"}</h3>
          <p>{device.name || device.device_key}</p>
        </div>
        <strong>{item.status_label || item.status || device.status || "-"}</strong>
      </div>

      <div className="main-card-skin-basic__values">
        {!rows.length ? (
          <div className="main-card-skin-basic__empty">표시할 최신 JSON 값이 없습니다.</div>
        ) : (
          rows.map(([key, value]) => (
            <div className="main-card-skin-basic__value" key={key}>
              <span>{key}</span>
              <strong>{String(value)}</strong>
            </div>
          ))
        )}
      </div>

      <div className="main-card-skin-basic__footer">
        <span>{card?.latest_event?.received_at || "수신 기록 없음"}</span>
        <Link to={`/monitor/devices/${device.device_key}`}>상세 보기</Link>
      </div>
    </article>
  );
}
